import { startTransition, useEffect, useState } from "react";

function appendParam(url, key, value) {
  if (value == null) return url;
  if (Array.isArray(value)) {
    value.forEach((v) => {
      if (v != null && v !== "") {
        url += `&${encodeURIComponent(`${key}[]`)}=${encodeURIComponent(v)}`;
      }
    });
    return url;
  }
  return `${url}&${key}=${encodeURIComponent(value)}`;
}

function buildDashboardUrl(dataUrl, startDate, endDate, extraParams) {
  let url = `${dataUrl}.json?start_date=${startDate}&end_date=${endDate}`;
  if (extraParams) {
    Object.entries(extraParams).forEach(([key, value]) => {
      url = appendParam(url, key, value);
    });
  }
  return url;
}

function syncExtraParamsToUrl(extraParams) {
  if (!extraParams) return;
  const url = new URL(window.location.href);
  Object.entries(extraParams).forEach(([key, value]) => {
    url.searchParams.delete(key);
    url.searchParams.delete(`${key}[]`);
    if (value == null) return;
    if (Array.isArray(value)) {
      value.forEach((v) => {
        if (v != null && v !== "") url.searchParams.append(`${key}[]`, v);
      });
    } else if (value !== "") {
      url.searchParams.set(key, value);
    }
  });
  window.history.replaceState({}, "", url);
}

function useAnalyticsDashboardData({ dataUrl, startDate, endDate, extraParams }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentStartDate, setCurrentStartDate] = useState(startDate);
  const [currentEndDate, setCurrentEndDate] = useState(endDate);

  useEffect(() => {
    syncExtraParamsToUrl(extraParams);
  }, [JSON.stringify(extraParams)]);

  useEffect(() => {
    let ignore = false;

    setLoading(true);

    fetch(buildDashboardUrl(dataUrl, currentStartDate, currentEndDate, extraParams))
      .then((res) => res.json())
      .then((json) => {
        if (ignore || !json.success) return;

        startTransition(() => {
          setData(json.data);
        });
      })
      .catch((err) => console.error("Analytics fetch error:", err))
      .finally(() => {
        if (!ignore) setLoading(false);
      });

    return () => {
      ignore = true;
    };
  }, [currentEndDate, currentStartDate, dataUrl, JSON.stringify(extraParams)]);

  const handleDateChange = (newStartDate, newEndDate) => {
    startTransition(() => {
      setCurrentStartDate(newStartDate);
      setCurrentEndDate(newEndDate);
    });

    const url = new URL(window.location.href);
    url.searchParams.set("start_date", newStartDate);
    url.searchParams.set("end_date", newEndDate);
    window.history.replaceState({}, "", url);
  };

  return {
    data,
    loading,
    currentStartDate,
    currentEndDate,
    handleDateChange,
  };
}

export default useAnalyticsDashboardData;
